import PropTypes from 'prop-types'
import React from 'react'

import './Headshot.css'


const Headshot = ({headshot, alt}) => {
  const img = headshot ? <img alt={alt} src={headshot} /> : false

  return (
    <div className="headshot">
      {img}
    </div>
  )
}


Headshot.propTypes = {
  headshot: PropTypes.string,
  alt: PropTypes.string
}


export default Headshot



// WEBPACK FOOTER //
// ./src/Headshot.js